import { Grid, Typography } from '@mui/material';
import React from 'react';

interface IHiringHeader {
  id: string;
  label: string;
}

const HiringHeader: React.FC<IHiringHeader> = ({
  id,
  label,
}: IHiringHeader) => {
  return (
    <Grid container id={`${id}-wrapper`} data-testid={`${id}-wrapper`}>
      <Grid item xs={12}>
        <Typography
          className='kfic2-pageTitleBold'
          id={`${id}-label`}
          data-testid={`${id}-label`}
          style={{
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
          }}
          title={label}
        >
          {label}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default HiringHeader;
